<script setup lang="ts">
import { computed, ref } from 'vue';
import { TurnstileStatusValue } from '../../types';
import Turnstile from './Turnstile.vue';

const emit = defineEmits<{
  statusChange: [status: TurnstileStatusValue, token: string | null];
}>();

const turnstileStatus = ref<TurnstileStatusValue>(TurnstileStatusValue.LOADING);

const isTurnstileVerified = computed(
  () => turnstileStatus.value === TurnstileStatusValue.VERIFIED,
);

function onTurnstileStatusChange(status: TurnstileStatusValue, token: string | null) {
  turnstileStatus.value = status;
  emit('statusChange', status, token);
}
</script>

<template>
  <div
    :inert="isTurnstileVerified"
    :class="[
      'mt-5 mb-2.5 transition-opacity duration-200',
      isTurnstileVerified && 'h-4 max-h-4 overflow-hidden opacity-0 pointer-events-none',
    ]"
  >
    <Turnstile @status-change="onTurnstileStatusChange" />
  </div>
  <slot name="footer" :verified="isTurnstileVerified" />
</template>
